import { render, staticRenderFns } from "./EventDetailsTimeslots.vue?vue&type=template&id=0bedc947&scoped=true&"
import script from "./EventDetailsTimeslots.vue?vue&type=script&lang=ts&"
export * from "./EventDetailsTimeslots.vue?vue&type=script&lang=ts&"
import style0 from "./EventDetailsTimeslots.vue?vue&type=style&index=0&id=0bedc947&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bedc947",
  null
  
)

export default component.exports